import * as React from 'react';

export class AccessDeniedSvg extends React.Component<{}> {
  
  render() {
    {/* tslint:disable:max-line-length */}
    return (
      <svg
        width="513px"
        height="210px"
        viewBox="0 0 513 210"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <defs>
          <polygon id="path-1" points="0 138 513 138 513 0 0 0"/>
        </defs>
        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g id="1" transform="translate(-543.000000, -309.000000)">
            <g id="Group-4" transform="translate(543.000000, 310.000000)">
              <g id="Page-1" transform="translate(0.000000, 71.000000)">
                <polygon id="Fill-1" fill="#FBFDFE" points="360 129 374 129 374 110 360 110"/>
                <polygon id="Fill-2" fill="#FBFDFE" points="388 129 402 129 402 97 388 97"/>
                <polygon id="Fill-3" fill="#FBFDFE" points="351 88 426 88 426 76 351 76"/>
                <path
                  d="M350,88 L425,88 L425,75 L350,75 L350,88 Z M350.625,87.35 L424.375,87.35 L424.375,75.65 L350.625,75.65 L350.625,87.35 Z"
                  id="Fill-4"
                  fill="#CEE9F2"
                />
                <path
                  d="M350,138 L425,138 L425,75 L350,75 L350,138 Z M351.25,136.740315 L423.75,136.740315 L423.75,76.26 L351.25,76.26 L351.25,136.740315 Z"
                  id="Fill-5"
                  fill="#CEE9F2"
                />
                <path
                  d="M359,129.34375 L360.22449,129.34375 L360.22449,109.65625 L359,109.65625 L359,129.34375 Z M359.612245,130 L373.387755,130 L373.387755,128.6875 L359.612245,128.6875 L359.612245,130 Z M372.77551,129.34375 L374,129.34375 L374,109.65625 L372.77551,109.65625 L372.77551,129.34375 Z M359.612245,110.3125 L373.387755,110.3125 L373.387755,109 L359.612245,109 L359.612245,110.3125 Z M359,130 L359.612245,130 L359.612245,129.34375 L359,129.34375 L359,130 Z M373.387755,130 L374,130 L374,129.34375 L373.387755,129.34375 L373.387755,130 Z M373.387755,109.65625 L374,109.65625 L374,109 L373.387755,109 L373.387755,109.65625 Z M359,109.65625 L359.612245,109.65625 L359.612245,109 L359,109 L359,109.65625 Z"
                  id="Fill-6"
                  fill="#CEE9F2"
                />
                <path
                  d="M374,128.363636 L375.22449,128.363636 L375.22449,115.636364 L374,115.636364 L374,128.363636 Z M374.612245,129 L388.387755,129 L388.387755,127.727273 L374.612245,127.727273 L374.612245,129 Z M387.77551,128.363636 L389,128.363636 L389,115.636364 L387.77551,115.636364 L387.77551,128.363636 Z M374.612245,116.272727 L388.387755,116.272727 L388.387755,115 L374.612245,115 L374.612245,116.272727 Z M374,129 L374.612245,129 L374.612245,128.363636 L374,128.363636 L374,129 Z M388.387755,129 L389,129 L389,128.363636 L388.387755,128.363636 L388.387755,129 Z M388.387755,115.636364 L389,115.636364 L389,115 L388.387755,115 L388.387755,115.636364 Z M374,115.636364 L374.612245,115.636364 L374.612245,115 L374,115 L374,115.636364 Z"
                  id="Fill-7"
                  fill="#CEE9F2"
                />
                <path
                  d="M387,129.365385 L388.22449,129.365385 L388.22449,97.6346154 L387,97.6346154 L387,129.365385 Z M387.612245,130 L401.387755,130 L401.387755,128.730769 L387.612245,128.730769 L387.612245,130 Z M400.77551,129.365385 L402,129.365385 L402,97.6346154 L400.77551,97.6346154 L400.77551,129.365385 Z M387.612245,98.2692308 L401.387755,98.2692308 L401.387755,97 L387.612245,97 L387.612245,98.2692308 Z M387,130 L387.612245,130 L387.612245,129.365385 L387,129.365385 L387,130 Z M401.387755,130 L402,130 L402,129.365385 L401.387755,129.365385 L401.387755,130 Z M401.387755,97.6346154 L402,97.6346154 L402,97 L401.387755,97 L401.387755,97.6346154 Z M387,97.6346154 L387.612245,97.6346154 L387.612245,97 L387,97 L387,97.6346154 Z"
                  id="Fill-8"
                  fill="#CEE9F2"
                />
                <path
                  d="M401,129.357143 L402.22449,129.357143 L402.22449,103.642857 L401,103.642857 L401,129.357143 Z M401.612245,130 L415.387755,130 L415.387755,128.714286 L401.612245,128.714286 L401.612245,130 Z M414.77551,129.357143 L416,129.357143 L416,103.642857 L414.77551,103.642857 L414.77551,129.357143 Z M401.612245,104.285714 L415.387755,104.285714 L415.387755,103 L401.612245,103 L401.612245,104.285714 Z M401,130 L401.612245,130 L401.612245,129.357143 L401,129.357143 L401,130 Z M415.387755,130 L416,130 L416,129.357143 L415.387755,129.357143 L415.387755,130 Z M415.387755,103.642857 L416,103.642857 L416,103 L415.387755,103 L415.387755,103.642857 Z M401,103.642857 L401.612245,103.642857 L401.612245,103 L401,103 L401,103.642857 Z"
                  id="Fill-9"
                  fill="#CEE9F2"
                />
                <polygon id="Fill-10" fill="#FBFDFE" points="9 53 23 53 23 34 9 34"/>
                <polygon id="Fill-11" fill="#FBFDFE" points="38 54 52 54 52 22 38 22"/>
                <polygon id="Fill-12" fill="#FBFDFE" points="0 12 75 12 75 0 0 0"/>
                <path
                  d="M0,13 L75,13 L75,0 L0,0 L0,13 Z M0.625,12.35 L74.375,12.35 L74.375,0.65 L0.625,0.65 L0.625,12.35 Z"
                  id="Fill-13"
                  fill="#CEE9F2"
                />
                <path
                  d="M0,63 L75,63 L75,0 L0,0 L0,63 Z M1.25,61.74 L73.75,61.74 L73.75,1.26 L1.25,1.26 L1.25,61.74 Z"
                  id="Fill-14"
                  fill="#CEE9F2"
                />
                <path
                  d="M9,53.34375 L10.2244898,53.34375 L10.2244898,33.65625 L9,33.65625 L9,53.34375 Z M9.6122449,54 L23.3877551,54 L23.3877551,52.6875 L9.6122449,52.6875 L9.6122449,54 Z M22.7755102,53.34375 L24,53.34375 L24,33.65625 L22.7755102,33.65625 L22.7755102,53.34375 Z M9.6122449,34.3125 L23.3877551,34.3125 L23.3877551,33 L9.6122449,33 L9.6122449,34.3125 Z M9,54 L9.6122449,54 L9.6122449,53.34375 L9,53.34375 L9,54 Z M23.3877551,54 L24,54 L24,53.34375 L23.3877551,53.34375 L23.3877551,54 Z M23.3877551,33.65625 L24,33.65625 L24,33 L23.3877551,33 L23.3877551,33.65625 Z M9,33.65625 L9.6122449,33.65625 L9.6122449,33 L9,33 L9,33.65625 Z"
                  id="Fill-15"
                  fill="#CEE9F2"
                />
                <path
                  d="M23,53.3636364 L24.2244898,53.3636364 L24.2244898,40.6363636 L23,40.6363636 L23,53.3636364 Z M23.6122449,54 L37.3877551,54 L37.3877551,52.7272727 L23.6122449,52.7272727 L23.6122449,54 Z M36.7755102,53.3636364 L38,53.3636364 L38,40.6363636 L36.7755102,40.6363636 L36.7755102,53.3636364 Z M23.6122449,41.2727273 L37.3877551,41.2727273 L37.3877551,40 L23.6122449,40 L23.6122449,41.2727273 Z M23,54 L23.6122449,54 L23.6122449,53.3636364 L23,53.3636364 L23,54 Z M37.3877551,54 L38,54 L38,53.3636364 L37.3877551,53.3636364 L37.3877551,54 Z M37.3877551,40.6363636 L38,40.6363636 L38,40 L37.3877551,40 L37.3877551,40.6363636 Z M23,40.6363636 L23.6122449,40.6363636 L23.6122449,40 L23,40 L23,40.6363636 Z"
                  id="Fill-16"
                  fill="#CEE9F2"
                />
                <path
                  d="M37,53.3653846 L38.2244898,53.3653846 L38.2244898,21.6346154 L37,21.6346154 L37,53.3653846 Z M37.6122449,54 L51.3877551,54 L51.3877551,52.7307692 L37.6122449,52.7307692 L37.6122449,54 Z M50.7755102,53.3653846 L52,53.3653846 L52,21.6346154 L50.7755102,21.6346154 L50.7755102,53.3653846 Z M37.6122449,22.2692308 L51.3877551,22.2692308 L51.3877551,21 L37.6122449,21 L37.6122449,22.2692308 Z M37,54 L37.6122449,54 L37.6122449,53.3653846 L37,53.3653846 L37,54 Z M51.3877551,54 L52,54 L52,53.3653846 L51.3877551,53.3653846 L51.3877551,54 Z M51.3877551,21.6346154 L52,21.6346154 L52,21 L51.3877551,21 L51.3877551,21.6346154 Z M37,21.6346154 L37.6122449,21.6346154 L37.6122449,21 L37,21 L37,21.6346154 Z"
                  id="Fill-17"
                  fill="#CEE9F2"
                />
                <path
                  d="M51,53.3571429 L52.2244898,53.3571429 L52.2244898,27.6428571 L51,27.6428571 L51,53.3571429 Z M51.6122449,54 L65.3877551,54 L65.3877551,52.7142857 L51.6122449,52.7142857 L51.6122449,54 Z M64.7755102,53.3571429 L66,53.3571429 L66,27.6428571 L64.7755102,27.6428571 L64.7755102,53.3571429 Z M51.6122449,28.2857143 L65.3877551,28.2857143 L65.3877551,27 L51.6122449,27 L51.6122449,28.2857143 Z M51,54 L51.6122449,54 L51.6122449,53.3571429 L51,53.3571429 L51,54 Z M65.3877551,54 L66,54 L66,53.3571429 L65.3877551,53.3571429 L65.3877551,54 Z M65.3877551,27.6428571 L66,27.6428571 L66,27 L65.3877551,27 L65.3877551,27.6428571 Z M51,27.6428571 L51.6122449,27.6428571 L51.6122449,27 L51,27 L51,27.6428571 Z"
                  id="Fill-18"
                  fill="#CEE9F2"
                />
                <polygon id="Fill-19" fill="#FBFDFE" points="175 88 337 88 337 76 175 76"/>
                <path
                  d="M175,88 L338,88 L338,75 L175,75 L175,88 Z M175.626923,87.35 L337.373077,87.35 L337.373077,75.65 L175.626923,75.65 L175.626923,87.35 Z"
                  id="Fill-20"
                  fill="#CEE9F2"
                />
                <path
                  d="M175,138 L338,138 L338,75 L175,75 L175,138 Z M176.253846,136.740315 L336.746154,136.740315 L336.746154,76.26 L176.253846,76.26 L176.253846,136.740315 Z"
                  id="Fill-21"
                  fill="#CEE9F2"
                />
                <polygon id="Fill-22" fill="#CEE9F2" points="327 129 329 129 329 123 327 123"/>
                <polygon id="Fill-23" fill="#CEE9F2" points="316 129 318 129 318 116 316 116"/>
                <polygon id="Fill-24" fill="#CEE9F2" points="305 129 307 129 307 123 305 123"/>
                <polygon id="Fill-25" fill="#CEE9F2" points="294 129 296 129 296 123 294 123"/>
                <polygon id="Fill-26" fill="#CEE9F2" points="284 129 286 129 286 123 284 123"/>
                <polygon id="Fill-27" fill="#CEE9F2" points="273 129 275 129 275 116 273 116"/>
                <polygon id="Fill-28" fill="#CEE9F2" points="261 129 263 129 263 123 261 123"/>
                <polygon id="Fill-29" fill="#CEE9F2" points="250 129 252 129 252 104 250 104"/>
                <polygon id="Fill-30" fill="#CEE9F2" points="239 129 241 129 241 110 239 110"/>
                <polygon id="Fill-31" fill="#CEE9F2" points="229 129 231 129 231 116 229 116"/>
                <polygon id="Fill-32" fill="#CEE9F2" points="218 129 220 129 220 97 218 97"/>
                <polygon id="Fill-33" fill="#CEE9F2" points="206 129 208 129 208 104 206 104"/>
                <polygon id="Fill-34" fill="#CEE9F2" points="195 129 197 129 197 97 195 97"/>
                <polygon id="Fill-35" fill="#CEE9F2" points="185 129 187 129 187 104 185 104"/>
                <g id="Group-110">
                  <path
                    d="M328.445122,127.963636 C292.595806,127.963636 274.700865,120.159423 256.749618,112.333882 C238.728304,104.477605 220.650997,96.6 184.554878,96.6 L184.554878,97.8545455 C220.403881,97.8545455 238.299135,105.658759 256.250382,113.4843 C274.271696,121.340577 292.349316,129.218182 328.445122,129.218182 L328.445122,127.963636 Z"
                    id="Fill-36"
                    fill="#CEE9F2"
                  />
                  <mask id="mask-2" fill="white">
                    <use xlinkHref="#path-1"/>
                  </mask>
                  <g id="Clip-39"/>
                  <polygon
                    id="Fill-38"
                    fill="#FBFDFE"
                    mask="url(#mask-2)"
                    points="87.8981707 12.2318182 249.931098 12.2318182 249.931098 0.313636364 87.8981707 0.313636364"
                  />
                  <path
                    d="M87.5853659,12.5454545 L250.243902,12.5454545 L250.243902,0 L87.5853659,0 L87.5853659,12.5454545 Z M88.2109756,11.9181818 L249.618293,11.9181818 L249.618293,0.627272727 L88.2109756,0.627272727 L88.2109756,11.9181818 Z"
                    id="Fill-40"
                    fill="#CEE9F2"
                    mask="url(#mask-2)"
                  />
                  <path
                    d="M87.5853659,62.7272727 L250.243902,62.7272727 L250.243902,0 L87.5853659,0 L87.5853659,62.7272727 Z M88.8365854,61.4727273 L248.992683,61.4727273 L248.992683,1.25454545 L88.8365854,1.25454545 L88.8365854,61.4727273 Z"
                    id="Fill-41"
                    fill="#CEE9F2"
                    mask="url(#mask-2)"
                  />
                  <polygon
                    id="Fill-42"
                    fill="#CEE9F2"
                    mask="url(#mask-2)"
                    points="96.9695122 38.2636364 240.859756 38.2636364 240.859756 37.0090909 96.9695122 37.0090909"
                  />
                  <path
                    d="M192.896133,53.9454545 C205.24567,53.9454545 211.4073,45.8310545 217.374991,38.0177455 C223.384599,30.1492364 229.200267,22.5818182 240.859756,22.5818182 L240.859756,21.3272727 C228.51022,21.3272727 222.348589,29.4416727 216.381523,37.2549818 C210.371916,45.1234909 204.556248,52.6909091 192.896133,52.6909091 L192.896133,53.9454545 Z M144.932823,22.5818182 C156.565098,22.5818182 162.38014,30.1486091 168.397255,38.0180591 C174.371828,45.8313682 180.547222,53.9454545 192.896133,53.9454545 L192.896133,52.6909091 C181.236018,52.6909091 175.406587,45.1231773 169.390098,37.2546682 C163.416776,29.4423 157.255145,21.3272727 144.932823,21.3272727 L144.932823,22.5818182 Z M96.9695122,53.9454545 C109.291522,53.9454545 115.453152,45.8304273 121.426787,38.0180591 C127.443276,30.14955 133.273021,22.5818182 144.932823,22.5818182 L144.932823,21.3272727 C132.583599,21.3272727 126.408518,29.4413591 120.433945,37.2546682 C114.41683,45.1241182 108.601474,52.6909091 96.9695122,52.6909091 L96.9695122,53.9454545 Z"
                    id="Fill-43"
                    fill="#CEE9F2"
                    mask="url(#mask-2)"
                  />
                  <path
                    d="M143.890244,127.963636 C139.060849,127.963636 135.131707,124.02405 135.131707,119.181818 C135.131707,114.339586 139.060849,110.4 143.890244,110.4 C148.719638,110.4 152.64878,114.339586 152.64878,119.181818 C152.64878,124.02405 148.719638,127.963636 143.890244,127.963636"
                    id="Fill-44"
                    fill="#FBFDFE"
                    mask="url(#mask-2)"
                  />
                  <path
                    d="M143.890244,109.772727 C138.707693,109.772727 134.506098,113.985491 134.506098,119.181818 C134.506098,124.378145 138.707693,128.590909 143.890244,128.590909 C149.072795,128.590909 153.27439,124.378145 153.27439,119.181818 C153.27439,113.985491 149.072795,109.772727 143.890244,109.772727 M143.890244,111.027273 C148.374615,111.027273 152.023171,114.685527 152.023171,119.181818 C152.023171,123.678109 148.374615,127.336364 143.890244,127.336364 C139.405873,127.336364 135.757317,123.678109 135.757317,119.181818 C135.757317,114.685527 139.405873,111.027273 143.890244,111.027273"
                    id="Fill-45"
                    fill="#CEE9F2"
                    mask="url(#mask-2)"
                  />
                  <polygon
                    id="Fill-46"
                    fill="#FBFDFE"
                    mask="url(#mask-2)"
                    points="87.8981707 87.5045455 162.345732 87.5045455 162.345732 75.5863636 87.8981707 75.5863636"
                  />
                  <path
                    d="M87.5853659,87.8181818 L162.658537,87.8181818 L162.658537,75.2727273 L87.5853659,75.2727273 L87.5853659,87.8181818 Z M88.2109756,87.1909091 L162.032927,87.1909091 L162.032927,75.9 L88.2109756,75.9 L88.2109756,87.1909091 Z"
                    id="Fill-47"
                    fill="#CEE9F2"
                    mask="url(#mask-2)"
                  />
                  <path
                    d="M87.5853659,138 L162.658537,138 L162.658537,75.2727273 L87.5853659,75.2727273 L87.5853659,138 Z M88.8365854,136.745455 L161.407317,136.745455 L161.407317,76.5272727 L88.8365854,76.5272727 L88.8365854,136.745455 Z"
                    id="Fill-48"
                    fill="#CEE9F2"
                    mask="url(#mask-2)"
                  />
                  <path
                    d="M112.609756,127.963636 C104.330749,127.963636 97.595122,121.210418 97.595122,112.909091 C97.595122,104.607764 104.330749,97.8545455 112.609756,97.8545455 C120.888763,97.8545455 127.62439,104.607764 127.62439,112.909091 C127.62439,121.210418 120.888763,127.963636 112.609756,127.963636"
                    id="Fill-49"
                    fill="#FBFDFE"
                    mask="url(#mask-2)"
                  />
                  <path
                    d="M112.609756,97.2272727 C103.971962,97.2272727 96.9695122,104.248336 96.9695122,112.909091 C96.9695122,121.569845 103.971962,128.590909 112.609756,128.590909 C121.24755,128.590909 128.25,121.569845 128.25,112.909091 C128.25,104.248336 121.24755,97.2272727 112.609756,97.2272727 M112.609756,98.4818182 C120.543739,98.4818182 126.99878,104.954018 126.99878,112.909091 C126.99878,120.864164 120.543739,127.336364 112.609756,127.336364 C104.675773,127.336364 98.2207317,120.864164 98.2207317,112.909091 C98.2207317,104.954018 104.675773,98.4818182 112.609756,98.4818182"
                    id="Fill-50"
                    fill="#CEE9F2"
                    mask="url(#mask-2)"
                  />
                  <path
                    d="M132.629268,97.2272727 C125.719096,97.2272727 120.117073,102.843873 120.117073,109.772727 C120.117073,116.701582 125.719096,122.318182 132.629268,122.318182 C139.539441,122.318182 145.141463,116.701582 145.141463,109.772727 C145.141463,102.843873 139.539441,97.2272727 132.629268,97.2272727 M132.629268,98.4818182 C138.838758,98.4818182 143.890244,103.546732 143.890244,109.772727 C143.890244,115.998723 138.838758,121.063636 132.629268,121.063636 C126.419779,121.063636 121.368293,115.998723 121.368293,109.772727 C121.368293,103.546732 126.419779,98.4818182 132.629268,98.4818182"
                    id="Fill-51"
                    fill="#CEE9F2"
                    mask="url(#mask-2)"
                  />
                  <polygon
                    id="Fill-52"
                    fill="#CEE9F2"
                    mask="url(#mask-2)"
                    points="458.322646 128.590909 459.573865 128.590909 459.573865 116.045455 458.322646 116.045455"
                  />
                  <polygon
                    id="Fill-53"
                    fill="#CEE9F2"
                    mask="url(#mask-2)"
                    points="447.310976 128.590909 448.562195 128.590909 448.562195 109.772727 447.310976 109.772727"
                  />
                  <polygon
                    id="Fill-54"
                    fill="#CEE9F2"
                    mask="url(#mask-2)"
                    points="469.331813 128.590909 470.583033 128.590909 470.583033 103.5 469.331813 103.5"
                  />
                  <polygon
                    id="Fill-55"
                    fill="#CEE9F2"
                    mask="url(#mask-2)"
                    points="480.343796 128.590909 481.595016 128.590909 481.595016 109.772727 480.343796 109.772727"
                  />
                  <polygon
                    id="Fill-56"
                    fill="#CEE9F2"
                    mask="url(#mask-2)"
                    points="491.352964 128.590909 492.604184 128.590909 492.604184 116.045455 491.352964 116.045455"
                  />
                  <polygon
                    id="Fill-57"
                    fill="#CEE9F2"
                    mask="url(#mask-2)"
                    points="502.364634 128.590909 503.615854 128.590909 503.615854 97.2272727 502.364634 97.2272727"
                  />
                  <polygon
                    id="Fill-58"
                    fill="#FBFDFE"
                    mask="url(#mask-2)"
                    points="438.239634 87.5045455 512.687195 87.5045455 512.687195 75.5863636 438.239634 75.5863636"
                  />
                  <path
                    d="M437.926829,87.8181818 L513,87.8181818 L513,75.2727273 L437.926829,75.2727273 L437.926829,87.8181818 Z M438.552439,87.1909091 L512.37439,87.1909091 L512.37439,75.9 L438.552439,75.9 L438.552439,87.1909091 Z"
                    id="Fill-59"
                    fill="#CEE9F2"
                    mask="url(#mask-2)"
                  />
                  <path
                    d="M437.926829,138 L513,138 L513,75.2727273 L437.926829,75.2727273 L437.926829,138 Z M439.178049,136.745455 L511.74878,136.745455 L511.74878,76.5272727 L439.178049,76.5272727 L439.178049,136.745455 Z"
                    id="Fill-60"
                    fill="#CEE9F2"
                    mask="url(#mask-2)"
                  />
                  <polygon
                    id="Fill-61"
                    fill="#CEE9F2"
                    mask="url(#mask-2)"
                    points="283.151914 53.3181818 284.403134 53.3181818 284.403134 40.7727273 283.151914 40.7727273"
                  />
                  <polygon
                    id="Fill-62"
                    fill="#CEE9F2"
                    mask="url(#mask-2)"
                    points="272.140244 53.3181818 273.391463 53.3181818 273.391463 34.5 272.140244 34.5"
                  />
                  <polygon
                    id="Fill-63"
                    fill="#CEE9F2"
                    mask="url(#mask-2)"
                    points="294.161082 53.3181818 295.412301 53.3181818 295.412301 28.2272727 294.161082 28.2272727"
                  />
                  <polygon
                    id="Fill-64"
                    fill="#CEE9F2"
                    mask="url(#mask-2)"
                    points="305.173065 53.3181818 306.424284 53.3181818 306.424284 34.5 305.173065 34.5"
                  />
                  <polygon
                    id="Fill-65"
                    fill="#CEE9F2"
                    mask="url(#mask-2)"
                    points="316.182232 53.3181818 317.433452 53.3181818 317.433452 40.7727273 316.182232 40.7727273"
                  />
                  <polygon
                    id="Fill-66"
                    fill="#CEE9F2"
                    mask="url(#mask-2)"
                    points="327.193902 53.3181818 328.445122 53.3181818 328.445122 21.9545455 327.193902 21.9545455"
                  />
                  <polygon
                    id="Fill-67"
                    fill="#FBFDFE"
                    mask="url(#mask-2)"
                    points="263.068902 12.2318182 337.516463 12.2318182 337.516463 0.313636364 263.068902 0.313636364"
                  />
                  <path
                    d="M262.756098,12.5454545 L337.829268,12.5454545 L337.829268,0 L262.756098,0 L262.756098,12.5454545 Z M263.381707,11.9181818 L337.203659,11.9181818 L337.203659,0.627272727 L263.381707,0.627272727 L263.381707,11.9181818 Z"
                    id="Fill-68"
                    fill="#CEE9F2"
                    mask="url(#mask-2)"
                  />
                  <path
                    d="M262.756098,62.7272727 L337.829268,62.7272727 L337.829268,0 L262.756098,0 L262.756098,62.7272727 Z M264.007317,61.4727273 L336.578049,61.4727273 L336.578049,1.25454545 L264.007317,1.25454545 L264.007317,61.4727273 Z"
                    id="Fill-69"
                    fill="#CEE9F2"
                    mask="url(#mask-2)"
                  />
                  <path
                    d="M494.231707,52.6909091 C489.402313,52.6909091 485.473171,48.7513227 485.473171,43.9090909 C485.473171,39.0668591 489.402313,35.1272727 494.231707,35.1272727 C499.061102,35.1272727 502.990244,39.0668591 502.990244,43.9090909 C502.990244,48.7513227 499.061102,52.6909091 494.231707,52.6909091"
                    id="Fill-70"
                    fill="#FBFDFE"
                    mask="url(#mask-2)"
                  />
                  <path
                    d="M494.231707,34.5 C489.049156,34.5 484.847561,38.7127636 484.847561,43.9090909 C484.847561,49.1054182 489.049156,53.3181818 494.231707,53.3181818 C499.414259,53.3181818 503.615854,49.1054182 503.615854,43.9090909 C503.615854,38.7127636 499.414259,34.5 494.231707,34.5 M494.231707,35.7545455 C498.716391,35.7545455 502.364634,39.4128 502.364634,43.9090909 C502.364634,48.4053818 498.716391,52.0636364 494.231707,52.0636364 C489.747024,52.0636364 486.09878,48.4053818 486.09878,43.9090909 C486.09878,39.4128 489.747024,35.7545455 494.231707,35.7545455"
                    id="Fill-71"
                    fill="#CEE9F2"
                    mask="url(#mask-2)"
                  />
                  <polygon
                    id="Fill-72"
                    fill="#FBFDFE"
                    mask="url(#mask-2)"
                    points="438.239634 12.2318182 512.687195 12.2318182 512.687195 0.313636364 438.239634 0.313636364"
                  />
                  <path
                    d="M437.926829,12.5454545 L513,12.5454545 L513,0 L437.926829,0 L437.926829,12.5454545 Z M438.552439,11.9181818 L512.37439,11.9181818 L512.37439,0.627272727 L438.552439,0.627272727 L438.552439,11.9181818 Z"
                    id="Fill-73"
                    fill="#CEE9F2"
                    mask="url(#mask-2)"
                  />
                  <path
                    d="M437.926829,62.7272727 L513,62.7272727 L513,0 L437.926829,0 L437.926829,62.7272727 Z M439.178049,61.4727273 L511.74878,61.4727273 L511.74878,1.25454545 L439.178049,1.25454545 L439.178049,61.4727273 Z"
                    id="Fill-74"
                    fill="#CEE9F2"
                    mask="url(#mask-2)"
                  />
                  <path
                    d="M462.95122,52.6909091 C454.672213,52.6909091 447.936585,45.9376909 447.936585,37.6363636 C447.936585,29.3350364 454.672213,22.5818182 462.95122,22.5818182 C471.230226,22.5818182 477.965854,29.3350364 477.965854,37.6363636 C477.965854,45.9376909 471.230226,52.6909091 462.95122,52.6909091"
                    id="Fill-75"
                    fill="#FBFDFE"
                    mask="url(#mask-2)"
                  />
                  <path
                    d="M462.95122,21.9545455 C454.313426,21.9545455 447.310976,28.9756091 447.310976,37.6363636 C447.310976,46.2971182 454.313426,53.3181818 462.95122,53.3181818 C471.589013,53.3181818 478.591463,46.2971182 478.591463,37.6363636 C478.591463,28.9756091 471.589013,21.9545455 462.95122,21.9545455 M462.95122,23.2090909 C470.885202,23.2090909 477.340244,29.6812909 477.340244,37.6363636 C477.340244,45.5914364 470.885202,52.0636364 462.95122,52.0636364 C455.017237,52.0636364 448.562195,45.5914364 448.562195,37.6363636 C448.562195,29.6812909 455.017237,23.2090909 462.95122,23.2090909"
                    id="Fill-76"
                    fill="#CEE9F2"
                    mask="url(#mask-2)"
                  />
                  <path
                    d="M482.970732,21.9545455 C476.060246,21.9545455 470.458537,27.5711455 470.458537,34.5 C470.458537,41.4288545 476.060246,47.0454545 482.970732,47.0454545 C489.881217,47.0454545 495.482927,41.4288545 495.482927,34.5 C495.482927,27.5711455 489.881217,21.9545455 482.970732,21.9545455 M482.970732,23.2090909 C489.180221,23.2090909 494.231707,28.2740045 494.231707,34.5 C494.231707,40.7259955 489.180221,45.7909091 482.970732,45.7909091 C476.761242,45.7909091 471.709756,40.7259955 471.709756,34.5 C471.709756,28.2740045 476.761242,23.2090909 482.970732,23.2090909"
                    id="Fill-77"
                    fill="#CEE9F2"
                    mask="url(#mask-2)"
                  />
                  <polygon
                    id="Fill-78"
                    fill="#CEE9F2"
                    mask="url(#mask-2)"
                    points="372.237805 25.7181818 378.493902 25.7181818 378.493902 24.4636364 372.237805 24.4636364"
                  />
                  <polygon
                    id="Fill-79"
                    fill="#CEE9F2"
                    mask="url(#mask-2)"
                    points="372.237805 38.2636364 378.493902 38.2636364 378.493902 37.0090909 372.237805 37.0090909"
                  />
                  <polygon
                    id="Fill-80"
                    fill="#CEE9F2"
                    mask="url(#mask-2)"
                    points="372.237805 50.8090909 378.493902 50.8090909 378.493902 49.5545455 372.237805 49.5545455"
                  />
                  <polygon
                    id="Fill-81"
                    fill="#FBFDFE"
                    mask="url(#mask-2)"
                    points="350.654268 12.2318182 425.101829 12.2318182 425.101829 0.313636364 350.654268 0.313636364"
                  />
                  <path
                    d="M350.341463,12.5454545 L425.414634,12.5454545 L425.414634,0 L350.341463,0 L350.341463,12.5454545 Z M350.967073,11.9181818 L424.789024,11.9181818 L424.789024,0.627272727 L350.967073,0.627272727 L350.967073,11.9181818 Z"
                    id="Fill-82"
                    fill="#CEE9F2"
                    mask="url(#mask-2)"
                  />
                  <path
                    d="M350.341463,62.7272727 L425.414634,62.7272727 L425.414634,0 L350.341463,0 L350.341463,62.7272727 Z M351.592683,61.4727273 L424.163415,61.4727273 L424.163415,1.25454545 L351.592683,1.25454545 L351.592683,61.4727273 Z"
                    id="Fill-83"
                    fill="#CEE9F2"
                    mask="url(#mask-2)"
                  />
                  <path
                    d="M400.390244,52.6909091 C392.110924,52.6909091 385.37561,45.9376909 385.37561,37.6363636 C385.37561,29.3350364 392.110924,22.5818182 400.390244,22.5818182 C408.669563,22.5818182 415.404878,29.3350364 415.404878,37.6363636 C415.404878,45.9376909 408.669563,52.6909091 400.390244,52.6909091"
                    id="Fill-84"
                    fill="#FFFFFF"
                    mask="url(#mask-2)"
                  />
                  <path
                    d="M400.390244,21.9545455 C391.75245,21.9545455 384.75,28.9756091 384.75,37.6363636 C384.75,46.2971182 391.75245,53.3181818 400.390244,53.3181818 C409.028038,53.3181818 416.030488,46.2971182 416.030488,37.6363636 C416.030488,28.9756091 409.028038,21.9545455 400.390244,21.9545455 M400.390244,23.2090909 C408.324227,23.2090909 414.779268,29.6812909 414.779268,37.6363636 C414.779268,45.5914364 408.324227,52.0636364 400.390244,52.0636364 C392.456261,52.0636364 386.00122,45.5914364 386.00122,37.6363636 C386.00122,29.6812909 392.456261,23.2090909 400.390244,23.2090909"
                    id="Fill-85"
                    fill="#CEE9F2"
                    mask="url(#mask-2)"
                  />
                  <path
                    d="M401.015854,38.2636364 L415.392053,38.2636364 C415.071428,46.0665955 408.798126,52.3565727 401.015854,52.67805 L401.015854,38.2636364 Z"
                    id="Fill-86"
                    fill="#FBFDFE"
                    mask="url(#mask-2)"
                  />
                  <path
                    d="M416.030488,37.6363636 L400.390244,37.6363636 L400.390244,53.3181818 C409.028038,53.3181818 416.030488,46.2971182 416.030488,37.6363636 M414.725466,38.8909091 C414.125193,45.8479909 408.580101,51.4078227 401.641463,52.0096909 L401.641463,38.8909091 L414.725466,38.8909091"
                    id="Fill-87"
                    fill="#CEE9F2"
                    mask="url(#mask-2)"
                  />
                  <path
                    d="M362.853659,27.6 C361.473876,27.6 360.35122,26.4743591 360.35122,25.0909091 C360.35122,23.7074591 361.473876,22.5818182 362.853659,22.5818182 C364.233441,22.5818182 365.356098,23.7074591 365.356098,25.0909091 C365.356098,26.4743591 364.233441,27.6 362.853659,27.6"
                    id="Fill-88"
                    fill="#FBFDFE"
                    mask="url(#mask-2)"
                  />
                  <path
                    d="M362.853659,21.9545455 C361.12635,21.9545455 359.72561,23.3590091 359.72561,25.0909091 C359.72561,26.8228091 361.12635,28.2272727 362.853659,28.2272727 C364.580967,28.2272727 365.981707,26.8228091 365.981707,25.0909091 C365.981707,23.3590091 364.580967,21.9545455 362.853659,21.9545455 M362.853659,23.2090909 C363.88873,23.2090909 364.730488,24.0530864 364.730488,25.0909091 C364.730488,26.1287318 363.88873,26.9727273 362.853659,26.9727273 C361.818587,26.9727273 360.976829,26.1287318 360.976829,25.0909091 C360.976829,24.0530864 361.818587,23.2090909 362.853659,23.2090909"
                    id="Fill-89"
                    fill="#CEE9F2"
                    mask="url(#mask-2)"
                  />
                  <path
                    d="M362.853659,40.1454545 C361.473876,40.1454545 360.35122,39.0198136 360.35122,37.6363636 C360.35122,36.2529136 361.473876,35.1272727 362.853659,35.1272727 C364.233441,35.1272727 365.356098,36.2529136 365.356098,37.6363636 C365.356098,39.0198136 364.233441,40.1454545 362.853659,40.1454545"
                    id="Fill-90"
                    fill="#FBFDFE"
                    mask="url(#mask-2)"
                  />
                  <path
                    d="M362.853659,34.5 C361.12635,34.5 359.72561,35.9044636 359.72561,37.6363636 C359.72561,39.3682636 361.12635,40.7727273 362.853659,40.7727273 C364.580967,40.7727273 365.981707,39.3682636 365.981707,37.6363636 C365.981707,35.9044636 364.580967,34.5 362.853659,34.5 M362.853659,35.7545455 C363.88873,35.7545455 364.730488,36.5985409 364.730488,37.6363636 C364.730488,38.6741864 363.88873,39.5181818 362.853659,39.5181818 C361.818587,39.5181818 360.976829,38.6741864 360.976829,37.6363636 C360.976829,36.5985409 361.818587,35.7545455 362.853659,35.7545455"
                    id="Fill-91"
                    fill="#CEE9F2"
                    mask="url(#mask-2)"
                  />
                  <path
                    d="M362.853659,52.6909091 C361.473876,52.6909091 360.35122,51.5652682 360.35122,50.1818182 C360.35122,48.7983682 361.473876,47.6727273 362.853659,47.6727273 C364.233441,47.6727273 365.356098,48.7983682 365.356098,50.1818182 C365.356098,51.5652682 364.233441,52.6909091 362.853659,52.6909091"
                    id="Fill-92"
                    fill="#FBFDFE"
                    mask="url(#mask-2)"
                  />
                  <path
                    d="M362.853659,47.0454545 C361.12635,47.0454545 359.72561,48.4499182 359.72561,50.1818182 C359.72561,51.9137182 361.12635,53.3181818 362.853659,53.3181818 C364.580967,53.3181818 365.981707,51.9137182 365.981707,50.1818182 C365.981707,48.4499182 364.580967,47.0454545 362.853659,47.0454545 M362.853659,48.3 C363.88873,48.3 364.730488,49.1439955 364.730488,50.1818182 C364.730488,51.2196409 363.88873,52.0636364 362.853659,52.0636364 C361.818587,52.0636364 360.976829,51.2196409 360.976829,50.1818182 C360.976829,49.1439955 361.818587,48.3 362.853659,48.3"
                    id="Fill-93"
                    fill="#CEE9F2"
                    mask="url(#mask-2)"
                  />
                  <polygon
                    id="Fill-94"
                    fill="#CEE9F2"
                    mask="url(#mask-2)"
                    points="21.8963415 100.990909 28.152439 100.990909 28.152439 99.7363636 21.8963415 99.7363636"
                  />
                  <polygon
                    id="Fill-95"
                    fill="#CEE9F2"
                    mask="url(#mask-2)"
                    points="21.8963415 113.536364 28.152439 113.536364 28.152439 112.281818 21.8963415 112.281818"
                  />
                  <polygon
                    id="Fill-96"
                    fill="#CEE9F2"
                    mask="url(#mask-2)"
                    points="21.8963415 126.081818 28.152439 126.081818 28.152439 124.827273 21.8963415 124.827273"
                  />
                  <polygon
                    id="Fill-97"
                    fill="#FBFDFE"
                    mask="url(#mask-2)"
                    points="0.312804878 87.5045455 74.7603659 87.5045455 74.7603659 75.5863636 0.312804878 75.5863636"
                  />
                  <path
                    d="M0,87.8181818 L75.0731707,87.8181818 L75.0731707,75.2727273 L0,75.2727273 L0,87.8181818 Z M0.625609756,87.1909091 L74.447561,87.1909091 L74.447561,75.9 L0.625609756,75.9 L0.625609756,87.1909091 Z"
                    id="Fill-98"
                    fill="#CEE9F2"
                    mask="url(#mask-2)"
                  />
                  <path
                    d="M0,138 L75.0731707,138 L75.0731707,75.2727273 L0,75.2727273 L0,138 Z M1.25121951,136.745455 L73.8219512,136.745455 L73.8219512,76.5272727 L1.25121951,76.5272727 L1.25121951,136.745455 Z"
                    id="Fill-99"
                    fill="#CEE9F2"
                    mask="url(#mask-2)"
                  />
                  <path
                    d="M50.0487805,127.963636 C41.769461,127.963636 35.0341463,121.210418 35.0341463,112.909091 C35.0341463,104.607764 41.769461,97.8545455 50.0487805,97.8545455 C58.3281,97.8545455 65.0634146,104.607764 65.0634146,112.909091 C65.0634146,121.210418 58.3281,127.963636 50.0487805,127.963636"
                    id="Fill-100"
                    fill="#FFFFFF"
                    mask="url(#mask-2)"
                  />
                  <path
                    d="M50.0487805,97.2272727 C41.4109866,97.2272727 34.4085366,104.248336 34.4085366,112.909091 C34.4085366,121.569845 41.4109866,128.590909 50.0487805,128.590909 C58.6865744,128.590909 65.6890244,121.569845 65.6890244,112.909091 C65.6890244,104.248336 58.6865744,97.2272727 50.0487805,97.2272727 M50.0487805,98.4818182 C57.9827634,98.4818182 64.4378049,104.954018 64.4378049,112.909091 C64.4378049,120.864164 57.9827634,127.336364 50.0487805,127.336364 C42.1147976,127.336364 35.6597561,120.864164 35.6597561,112.909091 C35.6597561,104.954018 42.1147976,98.4818182 50.0487805,98.4818182"
                    id="Fill-101"
                    fill="#CEE9F2"
                    mask="url(#mask-2)"
                  />
                  <path
                    d="M50.6743902,113.536364 L65.0505896,113.536364 C64.7299646,121.339323 58.4566628,127.6293 50.6743902,127.950777 L50.6743902,113.536364 Z"
                    id="Fill-102"
                    fill="#FBFDFE"
                    mask="url(#mask-2)"
                  />
                  <path
                    d="M65.6890244,112.909091 L50.0487805,112.909091 L50.0487805,128.590909 C58.6865744,128.590909 65.6890244,121.569845 65.6890244,112.909091 M64.3840024,114.163636 C63.7837299,121.120718 58.2386378,126.68055 51.3,127.282418 L51.3,114.163636 L64.3840024,114.163636"
                    id="Fill-103"
                    fill="#CEE9F2"
                    mask="url(#mask-2)"
                  />
                  <path
                    d="M12.5121951,102.872727 C11.1324128,102.872727 10.0097561,101.747086 10.0097561,100.363636 C10.0097561,98.9801864 11.1324128,97.8545455 12.5121951,97.8545455 C13.8919774,97.8545455 15.0146341,98.9801864 15.0146341,100.363636 C15.0146341,101.747086 13.8919774,102.872727 12.5121951,102.872727"
                    id="Fill-104"
                    fill="#FBFDFE"
                    mask="url(#mask-2)"
                  />
                  <path
                    d="M12.5121951,97.2272727 C10.7845738,97.2272727 9.38414634,98.6317364 9.38414634,100.363636 C9.38414634,102.095536 10.7845738,103.5 12.5121951,103.5 C14.2398165,103.5 15.6402439,102.095536 15.6402439,100.363636 C15.6402439,98.6317364 14.2398165,97.2272727 12.5121951,97.2272727 M12.5121951,98.4818182 C13.5472665,98.4818182 14.3890244,99.3258136 14.3890244,100.363636 C14.3890244,101.401459 13.5472665,102.245455 12.5121951,102.245455 C11.4771238,102.245455 10.6353659,101.401459 10.6353659,100.363636 C10.6353659,99.3258136 11.4771238,98.4818182 12.5121951,98.4818182"
                    id="Fill-105"
                    fill="#CEE9F2"
                    mask="url(#mask-2)"
                  />
                  <path
                    d="M12.5121951,115.418182 C11.1324128,115.418182 10.0097561,114.292541 10.0097561,112.909091 C10.0097561,111.525641 11.1324128,110.4 12.5121951,110.4 C13.8919774,110.4 15.0146341,111.525641 15.0146341,112.909091 C15.0146341,114.292541 13.8919774,115.418182 12.5121951,115.418182"
                    id="Fill-106"
                    fill="#FBFDFE"
                    mask="url(#mask-2)"
                  />
                  <path
                    d="M12.5121951,109.772727 C10.7845738,109.772727 9.38414634,111.177191 9.38414634,112.909091 C9.38414634,114.640991 10.7845738,116.045455 12.5121951,116.045455 C14.2398165,116.045455 15.6402439,114.640991 15.6402439,112.909091 C15.6402439,111.177191 14.2398165,109.772727 12.5121951,109.772727 M12.5121951,111.027273 C13.5472665,111.027273 14.3890244,111.871268 14.3890244,112.909091 C14.3890244,113.946914 13.5472665,114.790909 12.5121951,114.790909 C11.4771238,114.790909 10.6353659,113.946914 10.6353659,112.909091 C10.6353659,111.871268 11.4771238,111.027273 12.5121951,111.027273"
                    id="Fill-107"
                    fill="#CEE9F2"
                    mask="url(#mask-2)"
                  />
                  <path
                    d="M12.5121951,127.963636 C11.1324128,127.963636 10.0097561,126.837995 10.0097561,125.454545 C10.0097561,124.071095 11.1324128,122.945455 12.5121951,122.945455 C13.8919774,122.945455 15.0146341,124.071095 15.0146341,125.454545 C15.0146341,126.837995 13.8919774,127.963636 12.5121951,127.963636"
                    id="Fill-108"
                    fill="#FBFDFE"
                    mask="url(#mask-2)"
                  />
                  <path
                    d="M12.5121951,122.318182 C10.7845738,122.318182 9.38414634,123.722645 9.38414634,125.454545 C9.38414634,127.186445 10.7845738,128.590909 12.5121951,128.590909 C14.2398165,128.590909 15.6402439,127.186445 15.6402439,125.454545 C15.6402439,123.722645 14.2398165,122.318182 12.5121951,122.318182 M12.5121951,123.572727 C13.5472665,123.572727 14.3890244,124.416723 14.3890244,125.454545 C14.3890244,126.492368 13.5472665,127.336364 12.5121951,127.336364 C11.4771238,127.336364 10.6353659,126.492368 10.6353659,125.454545 C10.6353659,124.416723 11.4771238,123.572727 12.5121951,123.572727"
                    id="Fill-109"
                    fill="#CEE9F2"
                    mask="url(#mask-2)"
                  />
                </g>
                <polygon id="Fill-111" points="0 138 75 138 75 0 0 0"/>
                <polygon id="Fill-113" points="438 138 513 138 513 0 438 0"/>
              </g>
              <g id="Group-3" transform="translate(221.000000, 0.000000)">
                <path
                  d="M8,43 L64,43 C68.418278,43 72,46.581722 72,51 L72,96 C72,100.418278 68.418278,104 64,104 L8,104 C3.581722,104 5.41083001e-16,100.418278 0,96 L0,51 C-5.41083001e-16,46.581722 3.581722,43 8,43 Z"
                  id="Rectangle-2"
                  stroke="#CEE9F2"
                  strokeWidth="2"
                  fill="#F6FBFE"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M39.5,66.5 C39.5,68.7102959 37.7090591,70.5 35.5,70.5 C33.2890729,70.5 31.5,68.7109271 31.5,66.5 C31.5,64.2872045 33.2884405,62.5 35.5,62.5 C37.7096923,62.5 39.5,64.2878349 39.5,66.5 Z"
                  id="Stroke-2752"
                  stroke="#82BFD6"
                  strokeWidth="3"
                />
                <path d="M36,70 L36,84" id="Stroke-2753" stroke="#82BFD6" strokeWidth="2" opacity="0.463895089" strokeLinecap="round"/>
                <path
                  d="M63,39 L63,24.375 C63,11.9275 51.6428571,0 36.5,0 C21.3571429,0 10,11.9275 10,24.375 L10,39"
                  id="Stroke-2755"
                  stroke="#CEE9F2"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path d="" id="Path-2" stroke="#979797"/>
              </g>
            </g>
          </g>
        </g>
      </svg>
    )
  }
}